export default __webpack_public_path__ + "static/media/footerImg.efa1bcdf.png";